import React, { useContext } from 'react';

import { CheckoutContext } from './context';
// import { AuthUserContext } from '../Session';

import Row from '../Container/row';
import Col from '../Container/column';
import Summary from './summary';
import Form from './form';

import alertStyle from '../Alert/style';

import loadComponents from '../Loadable';

const Discount = loadComponents('checkout-discount');
// const Shipping = loadComponents('checkout-shipping');
const Totals = loadComponents('checkout-totals');
const Alert = loadComponents('alert');

const preOrderMessage = `Please note some of the items in your basket are pre-order items. These will be shipped as soon as we have stock available.`;

export default function CheckoutLayout(/* { shippingMethods } */) {
  const { checkout } = useContext(CheckoutContext);
  // const authUser = useContext(AuthUserContext);

  return (
    <>
      {checkout.error && (
        <Alert style={alertStyle} error>
          {checkout.error}
        </Alert>
      )}
      {checkout.success && (
        <Alert style={alertStyle} success>
          {checkout.success}
        </Alert>
      )}
      {checkout.preOrder && (
        <Alert style={alertStyle} info>
          {preOrderMessage}
        </Alert>
      )}
      <Row justify="space-between">
        <Col w={{ width: '25%' }} xxl={{ width: `30%` }} xl={{ width: `33%` }}>
          <Summary />
          <Discount />
          {/* {authUser === null && <Shipping methods={shippingMethods} />} */}
          <Totals />
        </Col>
        <Col
          className="checkoutForm"
          xxl={{ width: '60%' }}
          xl={{ width: '65%' }}
        >
          <Form />
        </Col>
      </Row>
    </>
  );
}
